/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseMCPListToolsCompletedEvent = {
  type: "response.mcp_list_tools.completed";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseMCPListToolsCompletedEvent$inboundSchema: z.ZodType<
  ResponseMCPListToolsCompletedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.mcp_list_tools.completed"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseMCPListToolsCompletedEvent$Outbound = {
  type: "response.mcp_list_tools.completed";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseMCPListToolsCompletedEvent$outboundSchema: z.ZodType<
  ResponseMCPListToolsCompletedEvent$Outbound,
  z.ZodTypeDef,
  ResponseMCPListToolsCompletedEvent
> = z.object({
  type: z.literal("response.mcp_list_tools.completed"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseMCPListToolsCompletedEventToJSON(
  responseMCPListToolsCompletedEvent: ResponseMCPListToolsCompletedEvent,
): string {
  return JSON.stringify(
    ResponseMCPListToolsCompletedEvent$outboundSchema.parse(
      responseMCPListToolsCompletedEvent,
    ),
  );
}
export function responseMCPListToolsCompletedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseMCPListToolsCompletedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseMCPListToolsCompletedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseMCPListToolsCompletedEvent' from JSON`,
  );
}
